import { Grid } from "@mui/material";
import * as React from "react";
import { Create, TextInput, SelectInput, required } from "react-admin";
import { StatusEnum } from "src/common/enum";
import { SimpleForm } from "src/enterprise/ra-rbac";

import { TaxClassCreateComponent } from ".";
export const TaxClassCreate = () => {
  return (
    <Create component={TaxClassCreateComponent}>
      <SimpleForm>
        <Grid container rowSpacing={1} columnSpacing={2}>
          <Grid item sm={12} lg={8}>
            <TextInput source="name" validate={required()} />
          </Grid>
          <Grid item sm={12} lg={8}>
            <SelectInput source="status" validate={required()} choices={StatusEnum} />
          </Grid>
        </Grid>
      </SimpleForm>
    </Create>
  );
};
